import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbsenceHeader } from 'src/app/Interfaces/hr/absence-header';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { CheckValidation } from 'src/app/shared/services/hr/CheckValidation.service';
import { EmployeeService } from 'src/app/shared/services/hr/employee.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { publicSettingService } from '../../../../shared/services/hr/publicSetting';
import { TranslateService } from '@ngx-translate/core';
import { SuperComponent } from 'src/app/pages/super/super.component';
import { DataShareService } from 'src/app/shared/services/data-share.service';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-add-edit-absence-rule-header-system',
  templateUrl: './add-edit-absence-rule-header-system.component.html',
  styleUrls: ['./add-edit-absence-rule-header-system.component.scss']
})
export class AddEditAbsenceRuleHeaderSystemComponent extends SuperComponent implements OnInit {
 ServerError$: Observable<any> = this.DataShareService.ServerError$;
 Absencename:string='';
 Absenceheaderid:number;
 Absencedropdown:any=[]
 AbsenceData:AbsenceHeader[]=[]
 dataSource:any=[];
 WeekDaysList:{}[]=[]
 absencedropdown:{}[]=[]
 typeDropDown:{}[]=[]
  constructor(public  publicService:publicSettingService, gt:genericCustomStoreService, translate:TranslateService,public DataShareService: DataShareService,
     Objects:ObjectsService,private validation:CheckValidation,public route:ActivatedRoute
    ,public router:Router,public _EmployeeService: EmployeeService) { 
      super(Objects,translate,gt)
      //dropdown
    gt.getdropdowndata("AbsenceRule").subscribe(res=>this.Absencedropdown=res)
    this.WeekDaysList=Objects.WeekDaysList
    this.gt.getdropdowndata("AbsenceRule/GetDropDown","DayRulesTypes").subscribe((data: {}[]) => {this.typeDropDown = data})
    this.absencedropdown=Objects.absenceRules;
    this.validateAsync = this.validateAsync.bind(this);

    //update
    this.publicService.$ACTIVE_ID.subscribe(res=>this.Absenceheaderid=res)
    if(this.Absenceheaderid!=0){
      this.loading=true;
      publicService.byKey("AbsenceRuleHeaderSystem",this.Absenceheaderid).subscribe((res:AbsenceHeader)=>{
        this.dataSource=res.rules
        this.Absencename=res.nameAr
        this.loading=false
      })
    }
    else{
      gt.getdropdowndata("AbsenceRuleHeaderSystem","GetEmptyRecord").subscribe((res:{rules:{}[]})=>this.dataSource=res.rules)
    }

  }

  ngOnInit(): void {
    this.DataShareService.removeServerError()
  }
  validateAsync (params:any) {
    var id = this.Absenceheaderid;
    return this.validation.asyncCheckNameValue(params.value,id,"AbsenceRuleHeaderSystem");
  
  }
  onFormSubmit(e:any){
    this.AbsenceData=[
      {
      id:this.Absenceheaderid,
      nameAr:this.Absencename,
      isDefault:false,
      rules:this.dataSource
    }
  ]
  if(this.Absenceheaderid!=0){
    this.publicService.update("AbsenceRuleHeaderSystem",this.AbsenceData[0]).subscribe(res=>{
      this.publicService.$ACTIVE_ReFRESH.next(true)
      this.router.navigate(['hr/AbsenceHeaderWorkSystem']) 
    })
     
  }
  else{
    this.publicService.add("AbsenceRuleHeaderSystem",this.AbsenceData[0]).subscribe(res=>{
      this.publicService.$ACTIVE_ReFRESH.next(true)
      this.router.navigate(['hr/AbsenceHeaderWorkSystem']) 
    })
  }
  }
onDefaultChanged(e: any) {
  console.log('Event triggered:', e); 
  
  
  if (!e.newData || !e.newData.hasOwnProperty('isDefault')) return;
  

  if (e.newData.isDefault === false) {
    const hasAnotherDefault = this.dataSource
      .some((x: any) => x.id !== e.key && x.isDefault === true);
    
    if (!hasAnotherDefault) {
      e.newData.isDefault = true;
      return;
    }
  }
 
  if (e.newData.isDefault === true) {
    this.dataSource.forEach((item: any) => {
      if (item.id !== e.key) {
        item.isDefault = false;
      }
    });
  }
}
  // backToMainPage(e:string){
  //   if(e=='back'){
  //     this.router.navigate(['/hr/AbsenceHeaderWorkSystem'])
  //   }
  // }
}